import WordingMixin from '@/mixins/Wording'
import EventHubMixin from '@/mixins/EventHub.js'

export default
{
    name: 'app-menu-trigger',

    mixins:
    [
        WordingMixin,
        EventHubMixin
    ],

    data()
    {
        return {
            active: false
        }
    },

    watch:
    {
        $route()
        {
            this.active = this.$route.name === 'menu'
        }
    },

    created()
    {
        this.active = this.$route.name === 'menu'
    },

    mounted()
    {
        document.addEventListener('keydown', (_event) =>
        {
            if(_event.keyCode === 27 && this.active)
            {
                _event.preventDefault()
                this.onClick()
            }
        })
    },

    methods:
    {
        onMouseEnter(_event)
        {
            this.$eventHub.$emit('grid.focusItem', _event.target)
        },

        onMouseLeave()
        {
            this.$eventHub.$emit('grid.unfocusItem')
        },

        onClick()
        {
            if(this.active)
            {
                this.$router.go(- 1)
            }
            else
            {
                this.$router.push({ name: 'menu' })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-menu-trigger/script.js